import moment from 'moment'

export const defaultState = () => {
    return {
        // data goes here
        eventList: [
            { name: 'Upper Cumberland Bigfoot Festival', url: 'https://ucbigfoot.com', location: 'Crossville, TN', start_date: '10/18/2025', end_date: '10/18/2025' },
            { name: 'Smokey Mountain Bigfoot Festival', url: 'https://www.thebigfest.com', location: 'Townsend, TN', start_date: '5/3/2025', end_date: '5/3/2025' },
            { name: 'WV Bigfoot Festival', url: 'https://wvbigfootmuseum.org/about-the-festival', location: 'Sutton, WV', start_date: '6/26/2025', end_date: '6/26/2025' },
            { name: 'Smokey Mountain Bigfoot Conference', url: 'https://gatherupevents.com/smoky-mountain-bigfoot-conference/', location: 'Gatlinburg, TN', start_date: '7/26/2025', end_date: '7/26/2025' }
        ]
        
    }
}

const state = defaultState()

const mutations = {

}

const actions = {

}

const getters = {
    getAllEvents (state) {
        // Sort data
        const sorted = state.eventList.sort(function(a, b) {
            return b.start_date - a.start_date;
        })
        return sorted
    },
    getFutureEvents (state) {
        // Filter by date, then sort
        const today = moment()
        const filtered = state.eventList.filter(item => today <= moment(item.start_date))
        console.log(filtered)
        const sorted = filtered.sort(function(a, b) {
            return  moment(a.start_date) -  moment(b.start_date);
        })
        return sorted
    },
    getPastEvents (state) {
        // Filter by date, then sort
        const today = moment()
        const filtered = state.eventList.filter(item => today >= moment(item.start_date))
        const sorted = filtered.sort(function(a, b) {
            return  moment(a.start_date) -  moment(b.start_date);
        })
        return sorted
    }
}

export const events = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}